import React, { Component } from "react";
import {
  getCategoryListRequest,
  updateCategoryStatusByCategoryIdRequest,
  deleteCategoryByCategoryIdRequest,
} from "store/actions";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import Switch from "react-switch";
import { makeCategorySelectField } from "store/Masters/Category/selector";
import { createStructuredSelector } from "reselect";
import CustomDataTable from "components/Application/CustomDataTable";
import { confirmBox } from "helpers/messageHelper";
import { primaryColor, secondaryColor } from "scss/variables.module.scss";
import CircularIconButton from "components/Buttons/CircularIconButton";

const columns = [
  {
    label: "Sequence",
    field: "categorySeq",
  },
  {
    label: "Image",
    field: "categoryImage",
  },
  {
    label: "Category Name",
    field: "categoryName",
  },
  {
    label: "Has Sub Category",
    field: "hasSubCategory",
  },
  {
    label: "Status",
    field: "status",
    sort: "disabled",
  },
  {
    label: "Actions",
    field: "actions",
    sort: "disabled",
  },
];

class CategoryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryRecords: [],
    };
  }

  componentDidMount() {
    //Retrieve category list
    this.props.getCategoryListRequest();
  }

  onStatusChange = (checked, e, id) => {
    this.props.updateCategoryStatusByCategoryIdRequest(id, checked);
  };

  buildCategoryDataTable = (records) => {
    this.setState({
      categoryRecords: records.map((category) => {
        let imageView = (
          <img
            className="img-thumbnail"
            src={category.categoryImageUrl}
            alt={category.categoryName}
            width="150"
          />
        );

        let actions = (
          <div className="text-center">
            <CircularIconButton
              icon="far fa-edit fa-lg"
              onClick={this.viewCategory(category)}
              tooltip={"Edit"}
            />

            <CircularIconButton
              icon="far fa-trash-alt fa-lg"
              onClick={this.deleteCategory(category.categoryId)}
              tooltip={"Delete"}
            />
          </div>
        );

        let status = (
          <div className="d-flex">
            <Switch
              className="switch-sm"
              onColor={primaryColor}
              offColor={secondaryColor}
              onChange={(checked, e, id) => this.onStatusChange(checked, e, id)}
              id={category.categoryId + ""}
              checked={category.status ? true : false}
            />
            &nbsp;
          </div>
        );

        return {
          categorySeq: category.categorySeq,
          categoryImage: imageView,
          categoryName: category.categoryName,
          hasSubCategory: category.hasSubCategory ? "Yes" : "No",
          status: status,
          actions: actions,
        };
      }),
    });
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (this.props.categoryData !== nextprops.categoryData) {
      this.buildCategoryDataTable(nextprops.categoryData);
    }
  }

  viewCategory = (categoryData) => () => {
    this.props.onViewCategory(categoryData);
  };

  deleteCategory = (categoryId) => async () => {
    const response = await confirmBox();
    if (response) {
      this.props.deleteCategoryByCategoryIdRequest(categoryId);
    }
  };

  render() {
    const data = {
      columns: columns,
      rows: this.state.categoryRecords,
    };

    return (
      <React.Fragment>
        <CustomDataTable data={data} />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  categoryData: makeCategorySelectField("categoryData"),
});

const withConnect = connect(mapStatetoProps, {
  getCategoryListRequest,
  updateCategoryStatusByCategoryIdRequest,
  deleteCategoryByCategoryIdRequest,
});

export default compose(withConnect, withRouter)(CategoryList);
